import React, { PureComponent } from "react";
import { withRouter, Switch } from "react-router-dom";
import { Dimmer, Modal, Button, Icon } from "semantic-ui-react";
import { isIOS } from "react-device-detect";
import PWAPrompt from "react-ios-pwa-prompt";
import { getLabel } from "./constants/Strings";
import Cookie from "react-cookies";

//Redux
import { connect } from "react-redux";
import { logout, rehydrate } from "./redux/actions/user";
import { importSettings } from "./redux/actions/settings";
import { dismissErrors } from "./redux/actions/error";
import { dismissSuccess } from "./redux/actions/success";
//import { newTransaction } from "./redux/actions/transactions";
//Components
import IdleTimer from "react-idle-timer";
import PublicRoute from "./components/PublicRoute/PublicRoute";
import ProtectedRoute from "./components/ProtectedRoute/ProtectedRoute";
import Loading from "./components/Loading/Loading";
import ErrorDialog from "./components/ErrorDialog/ErrorDialog";
import SuccessDialog from "./components/SuccessDialog/SuccessDialog";
//Screens
import LoginScreen from "./screens/LoginScreen/LoginScreen";
import ForgotPasswordScreen from "./screens/ForgotPasswordScreen/ForgotPasswordScreen";
import SignUpScreen from "./screens/SignUpScreen/SignUpScreen";
import HomeScreen from "./screens/HomeScreen/HomeScreen";
import GameScreen from "./screens/GameScreen/GameScreen";
import SettingsScreen from "./screens/SettingsScreen/SettingsScreen";
import OperationScreen from "./screens/OperationScreen/OperationScreen";
import RulesScreen from "./screens/RulesScreen/RulesScreen";
import TransactionScreen from "./screens/TransactionScreen/TransactionScreen";
import WithDrawScreen from "./screens/WithDrawScreen/WithDrawScreen";
import NotificationScreen from "./screens/NotificationScreen/NotificationScreen";
import DashboardScreen from "./screens/DashboardScreen/DashboardScreen";
import ValidationTransactionScreen from "./screens/ValidationTransactionScreen/ValidationTransactionScreen";
import WinnerScreen from "./screens/WinnerScreen/WinnerScreen";
import UserCreditScreen from "./screens/UserCreditScreen/UserCreditScreen";
import DisplayUsersScreen from "./screens/DisplayUsersScreen/DisplayUsersScreen";
import SetWinningRangeForm from "./screens/SetWinningRangeForm/SetWinningRangeForm";
import CreateInvestorScreen from "./screens/CreateInvestorScreen/CreateInvestorScreen";
import InvestorReportScreen from "./screens/InvestorReportScreen/InvestorReportScreen";
import ManageInvestorsScreen from "./screens/ManageInvestorsScreen/ManageInvestorsScreen";
import MaintenanceScreen from "./screens/MaintenanceScreen/MaintenanceScreen";
import config from "./config";

class App extends PureComponent {
  constructor(props) {
    super(props);

    // Migration logic for new cookie settings
    const MIGRATION_VERSION = "v1.1_cookies";
    if (localStorage.getItem("app_version") !== MIGRATION_VERSION && !window.location.hostname.includes("localhost")) {
      // Clear cookies
      const cookies = Cookie.loadAll();
      Object.keys(cookies).forEach((name) => Cookie.remove(name, { path: "/" }));

      // Clear everything else
      localStorage.clear();
      sessionStorage.clear();

      // Set new version and reload
      localStorage.setItem("app_version", MIGRATION_VERSION);
      window.location.reload();
      return;
    }

    this.state = {
      installModalIOS: false,
      installModalAndroid: false,
      isOutdated: localStorage.getItem("show_update_notice") === "true",
    };

    this.props.dispatch(importSettings());
    this.props.dispatch(rehydrate());
    window.scrollTo(0, 0);
    this.installPrompt = null;
  }

  componentDidMount = async () => {
    this.checkVersion();
    // Check for updates every 15 minutes to force users on old versions to update
    this.versionInterval = setInterval(this.checkVersion, 1000 * 60 * 15);

    if (
      isIOS &&
      (!window.matchMedia("(display-mode: standalone)").matches ||
        !window.navigator.standalone)
    ) {
      //console.log("Opened on IOS");
      this.setState({ installModalIOS: true });
    } else {
      var cookie = await Cookie.load("visited");
      if (cookie === undefined) {
        //console.log("Opened on Android or Desktop");
        Cookie.save("visited", { visited: true }, { path: "/", maxAge: 3600 });
        window.addEventListener("beforeinstallprompt", (e) => {
          // See if the app is already installed, in that case, do nothing
          if (
            (window.matchMedia &&
              window.matchMedia("(display-mode: standalone)").matches) ||
            window.navigator.standalone === true
          ) {
            return false;
          }
          this.installPrompt = e;
          this.setState({ installModalAndroid: true });
        });
      }
    }
  };

  checkVersion = async () => {
    try {
      // Fetch version.json with a cache-busting timestamp
      const response = await fetch(`/version.json?t=${new Date().getTime()}`, {
        cache: "no-store",
      });
      const data = await response.json();
      const serverVersion = data.version;
      const localVersion = localStorage.getItem("tizemilyon_version");

      if (serverVersion && serverVersion !== localVersion) {
        // Only reload if we already had a version (prevents reload on first visit)
        if (localVersion) {
          localStorage.setItem("tizemilyon_version", serverVersion);

          // Clear all caches for the PWA/Browser
          if ("caches" in window) {
            try {
              const cacheNames = await caches.keys();
              await Promise.all(cacheNames.map((name) => caches.delete(name)));
            } catch (e) {
              console.error("Failed to clear caches:", e);
            }
          }

          // Unregister any active service workers to ensure fresh loading
          if ("serviceWorker" in navigator) {
            try {
              const registrations = await navigator.serviceWorker.getRegistrations();
              await Promise.all(registrations.map((r) => r.unregister()));
            } catch (e) {
              console.error("Failed to unregister SW:", e);
            }
          }

          // Show the outdated version message instead of just reloading
          localStorage.setItem("show_update_notice", "true");
          this.setState({ isOutdated: true });
          
          // Still try to reload in the background to help clear things
          setTimeout(() => {
             // window.location.reload(true);
          }, 2000);
        } else {
          // Versions match, clear any notice
          localStorage.removeItem("show_update_notice");
          this.setState({ isOutdated: false });

          // First time visit, just set the version
          localStorage.setItem("tizemilyon_version", serverVersion);
        }
      }
    } catch (error) {
      console.error("Failed to check app version:", error);
    }
  };

  componentWillUnmount() {
    if (this.versionInterval) {
      clearInterval(this.versionInterval);
    }
  }

  componentDidUpdate = (prevProps) => {
    if (prevProps.user.id && !this.props.user.id) {
      this.props.history.push("/"); // Redirect to login
    }
  };

  onIdle = () => {
    if (this.props.isLoggedIn) {
      return this.props.dispatch(logout());
    }
  };

  closeIOSModal = () => {
    this.setState({ installModalIOS: false });
  };

  closeAndroidModal = () => {
    this.setState({ installModalAndroid: false });
  };

  handleInstallApp = async () => {
    this.installPrompt.prompt();
    const { outcome } = await this.installPrompt.userChoice;
    if (outcome === "accepted") {
      //console.log("Installed");
      this.setState({ installModalAndroid: false });
    } else {
      //console.log("Not Installed");
      this.setState({ installModalAndroid: false });
    }
  };

  handleDismissErrors = (e) => {
    e.preventDefault();
    this.props.dispatch(dismissErrors());
  };

  handleDismissSuccess = (e) => {
    e.preventDefault();
    this.props.dispatch(dismissSuccess());
  };

  render() {
    const { loading, isLoggedIn, error, success, user } = this.props;
    const { installModalAndroid, installModalIOS, isOutdated } = this.state;

    if (isOutdated) {
      return (
        <Dimmer active page>
          <Modal open={true} size="small" basic style={{ textAlign: 'center' }}>
            <Icon name="cloud download" size="huge" inverted />
            <h1 style={{ fontSize: '2.5rem', color: 'white', marginTop: '20px' }}>{getLabel("UpdateTitle")}</h1>
            <Modal.Content>
              <p style={{ fontSize: '1.5rem', color: 'rgba(255,255,255,0.9)', lineHeight: '1.6' }}>
                {getLabel("UpdateBody")}
              </p>
            </Modal.Content>
          </Modal>
        </Dimmer>
      );
    }

    if (config.isMaintenance && user.role !== "ADMIN") {
      return <MaintenanceScreen />;
    }

    if (user.id !== null) {
      return (
        <Dimmer.Dimmable
          blurring
          dimmed={loading.isFetching || error.error || success.success}
        >
          <Modal open={installModalAndroid} onClose={this.closeAndroidModal}>
            <Modal.Content>
              <h3>{getLabel("PromptTitle")}</h3>
              <p>{getLabel("PromptBody")}</p>
            </Modal.Content>
            <Modal.Actions>
              <Button fluid onClick={this.handleInstallApp} color={"green"}>
                {getLabel("Install")}
              </Button>
            </Modal.Actions>
          </Modal>
          <Modal open={installModalIOS} onClose={this.closeIOSModal}>
            <PWAPrompt
              timesToShow={5}
              delay={0}
              permanentlyHideOnDismiss={false}
              copyTitle={getLabel("PromptTitle")}
              copyBody={getLabel("PromptBody")}
              copyShareButtonLabel={getLabel("Prompt1")}
              copyAddHomeButtonLabel={getLabel("Prompt2")}
              copyClosePrompt={getLabel("Cancel")}
            />
          </Modal>
          <Loading isFetching={loading.isFetching} />
          <ErrorDialog
            error={error.error}
            title={error.errorTitle}
            text={error.errorText}
            onPress={this.handleDismissErrors}
          />
          <SuccessDialog
            success={success.success}
            title={success.successTitle}
            text={success.successText}
            onPress={this.handleDismissSuccess}
          />
          <IdleTimer
            ref={(ref) => {
              this.idleTimer = ref;
            }}
            element={document}
            onIdle={this.onIdle}
            timeout={1000 * 60 * 15}
          />
          <Switch>
            <PublicRoute
              isLoggedIn={isLoggedIn}
              role={user.role}
              exact
              path={"/"}
              component={LoginScreen}
            />

            <PublicRoute
              isLoggedIn={isLoggedIn}
              role={user.role}
              exact
              path={"/sign-up"}
              component={SignUpScreen}
            />

            <PublicRoute
              isLoggedIn={isLoggedIn}
              role={user.role}
              exact
              path={"/forgot-password"}
              component={ForgotPasswordScreen}
            />

            <ProtectedRoute
              isLoggedIn={isLoggedIn}
              role={user.role}
              exact
              path={"/home-screen"}
              component={HomeScreen}
            />

            <ProtectedRoute
              isLoggedIn={isLoggedIn}
              role={user.role}
              path={"/play-game"}
              component={GameScreen}
            />

            <ProtectedRoute
              isLoggedIn={isLoggedIn}
              role={user.role}
              path={"/settings"}
              component={SettingsScreen}
            />
            <ProtectedRoute
              isLoggedIn={isLoggedIn}
              role={user.role}
              exact
              path={"/operation"}
              component={OperationScreen}
            />
            <ProtectedRoute
              isLoggedIn={isLoggedIn}
              role={user.role}
              exact
              path={"/withdraw"}
              component={WithDrawScreen}
            />
            <ProtectedRoute
              isLoggedIn={isLoggedIn}
              role={user.role}
              exact
              path={"/rules-screen"}
              component={RulesScreen}
            />
            <ProtectedRoute
              isLoggedIn={isLoggedIn}
              role={user.role}
              exact
              path={"/transaction"}
              component={TransactionScreen}
            />

            <ProtectedRoute
              isLoggedIn={isLoggedIn}
              role={user.role}
              exact
              path={"/notification"}
              component={NotificationScreen}
            />

            <ProtectedRoute
              isLoggedIn={isLoggedIn}
              role={user.role}
              exact
              path={"/dashboard"}
              component={DashboardScreen}
            />

            <ProtectedRoute
              isLoggedIn={isLoggedIn}
              role={user.role}
              exact
              path={"/validation"}
              component={ValidationTransactionScreen}
            />

            <ProtectedRoute
              isLoggedIn={isLoggedIn}
              role={user.role}
              exact
              path={"/winner"}
              component={WinnerScreen}
            />
            <ProtectedRoute
              isLoggedIn={isLoggedIn}
              role={user.role}
              exact
              path={"/user-credit"}
              component={UserCreditScreen}
            />

            <ProtectedRoute
              isLoggedIn={isLoggedIn}
              role={user.role}
              exact
              path={"/user-list"}
              component={DisplayUsersScreen}
            />

            <ProtectedRoute
              isLoggedIn={isLoggedIn}
              role={user.role}
              exact
              path={"/create-investor"}
              component={CreateInvestorScreen}
            />

            <ProtectedRoute
              isLoggedIn={isLoggedIn}
              role={user.role}
              exact
              path={"/investor-report"}
              component={InvestorReportScreen}
            />

            <ProtectedRoute
              isLoggedIn={isLoggedIn}
              role={user.role}
              exact
              path={"/manage-investors"}
              component={ManageInvestorsScreen}
            />

            <ProtectedRoute
              isLoggedIn={isLoggedIn}
              role={user.role}
              exact
              path={"/settings-win"}
              component={SetWinningRangeForm}
            />
          </Switch>
        </Dimmer.Dimmable>
      );
    } else {
      return (
        <PublicRoute
          isLoggedIn={isLoggedIn}
          role={user.role}
          exact
          path={"/"}
          component={LoginScreen}
        />
        // <Dimmer.Dimmable blurring dimmed={true}>
        // 	<Loading isFetching={true} />
        // </Dimmer.Dimmable>
      );
    }
  }
}

function mapStateToProps({ loading, user, error, success }) {
  const isLoggedIn = user.id !== null && user.id !== undefined;
  return { loading, error, success, user, isLoggedIn: isLoggedIn };
}

export default withRouter(connect(mapStateToProps)(App));
